import { BufferAttribute, BufferGeometry, Mesh, MeshStandardMaterial, type Group, type Material } from 'three'
import type asset from '../../SourceArt/PierGlazing/mesh.json'
import { bodyLengthFor, playfieldCentreY, type CabinetDimensions } from './cabinet'
let data:typeof asset|undefined
export async function prepareAuthoredGlazing():Promise<void>{data??=(await import('../../SourceArt/PierGlazing/mesh.json')).default}
export function authoredGlazingFor(id:string|undefined,d:CabinetDimensions){
  const t=data?.tables.find(t=>id!==undefined&&t.machineId===id)
  if(!t||Math.abs(t.cabinetWidth-d.width)>1e-8||Math.abs(t.cabinetLength-bodyLengthFor(d))>1e-8||Math.abs(t.incline-d.incline)>1e-8
    ||Math.abs(t.requiredTotalVerticalRecess-(d.playfieldRecess??.03))>1e-8||d.glassHeight!==t.declaredGlassHeight||d.height!==t.cabinetHeight
    ||d.lockdownBarHeight!==t.lockdownBarHeight||d.playfieldLength!==t.playfieldLength||d.playfieldWidth!==t.playfieldWidth
    ||Math.abs(t.boardOrigin[1]!-(playfieldCentreY({...d,playfieldRecess:.03})))>5e-7)return undefined
  return t
}
export function addAuthoredGlazing(t:NonNullable<ReturnType<typeof authoredGlazingFor>>,group:Group,geometries:BufferGeometry[],materials:Material[]):void{
  for(const p of t.parts){
    const g=new BufferGeometry();g.setAttribute('position',new BufferAttribute(new Float32Array(p.positions),3));g.setAttribute('normal',new BufferAttribute(new Float32Array(p.normals),3));g.setAttribute('uv',new BufferAttribute(new Float32Array(p.uvs),2));g.setIndex(p.triangles);g.computeBoundingBox();g.computeBoundingSphere()
    const glass=p.finish==='GlazingGlass',steel=p.finish==='GlazingSteel'
    const m=new MeshStandardMaterial({color:glass?0xffffff:steel?0xcdd1d6:0x050809,metalness:steel?1:0,roughness:glass?.02:steel?.50:.75,transparent:glass,depthWrite:!glass})
    m.name='glazing.'+p.finish
    if(glass){
      // Dielectric reflection over the existing scene, without a transmission framebuffer.
      m.onBeforeCompile=shader=>{shader.fragmentShader=shader.fragmentShader.replace('#include <lights_physical_fragment>', `#include <lights_physical_fragment>
material.specularColor=vec3(0.004);
material.specularColorBlended=vec3(0.004);
material.specularF90=1.0;`).replace('#include <opaque_fragment>',`float glazingFacing=1.0-abs(dot(normal,geometryViewDir));
float glazingF=0.004+0.996*pow(glazingFacing,8.0);
float glazingReferenceF=0.004+0.996*pow(glazingFacing,5.0);
outgoingLight=reflectedLight.indirectSpecular/max(glazingReferenceF,0.0001);
diffuseColor.a=glazingF;
#include <opaque_fragment>`)}
      m.customProgramCacheKey=()=> 'HCC-glazing-environment-coated-03'
    }
    const mesh=new Mesh(g,m);mesh.name='glazing.authored.'+p.finish;group.add(mesh);geometries.push(g);materials.push(m)
  }
}
